import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  root: css`
    padding-inline: ${spacing(2)}; // 16px
    padding-block-end: ${spacing(1.5)} // 12px

    overflow-x: scroll;
    /* Disable scrollbar */
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }
  `,
}
